import { graphql, useStaticQuery } from "gatsby";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Modal from "./modal";
import SliderRelated from "./slider-related";
import classNames from "classnames";
import { Link } from "./link";
import safeSlugify from "../utility/safe-slugify";
import { normalizeRelativePath } from "../utility/paths";
import { hasEcommerce } from "../utility/ecommerce";

const CartModal = ({
  show,
  onHide,
  msg,
  msgKey,
  icon = "tick",
  cartUrl,
  loading,
  productId,
  sliderProducts,
  lineId,
  isEcommerce,
}) => {
  const ref = useRef(null);
  const ecommerceActive = hasEcommerce && [undefined, "[]"].includes(isEcommerce);

  const { labelManagerLabels, sliderProductsACLine, config } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        goToCart
        continueOnTheShop
        anErrorAsOccurred
        itemAddedToCart
        noProductsInCart
        relatedProducts
        cartModalRelatedProducts
        cartModalRelatedProductsAc
        addToCart
        preorder
        whereToBuy
        showProduct
        discoverMore
        buyNow
      }
      sliderProductsACLine: liferayPageLine(lineId: { eq: "333" }, isCategory: { eq: true }) {
        slug
        lineId
      }
      config: liferayGeneralConfiguration {
        haierStEcommLines {
          productLine
        }
        isReevooActiveFieldSet {
          isReevooActive
          isBazaarVoiceActive
        }
        priceInPerc: priceInPerc
        wtbAndRetailersActive
        currency
        tagActive
        tagColor
        invertProductFamily
        acCompare
        disableQuantitySelector
      }
    }
  `);

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onHide();
      }
    },
    [onHide]
  );

  const [isProducts, setIsProducts] = useState(false);

  return (
    <Modal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex, jsx-a11y/no-noninteractive-element-interactions */}
      <div
        ref={ref}
        className={`cart-modal${show ? " show" : ""}`}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={show ? 0 : -1}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        role="dialog"
        aria-hidden={!show || !cartUrl}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        onKeyDown={onKeyDown}
      >
        {loading ? (
          <div className="cart-modal__loading">
            <div className="spinner-border"></div>
          </div>
        ) : (
          <div
            className={classNames(
              "cart-modal__dialog",
              isProducts && "cart-modal__dialog--related"
            )}
            role="document"
          >
            <div className="text-center">
              {icon ? (
                <div className={`cart-modal__icon cart-modal__icon--${icon}`}>
                  <span className={`icon-${icon}`}></span>
                </div>
              ) : null}
              <div className="cart-modal__title mt-3 mt-md-4">
                {msgKey && labelManagerLabels[msgKey] ? labelManagerLabels[msgKey] : msg}
              </div>
              {cartUrl ? (
                <div className="mt-3 mt-md-4">
                  <a href={cartUrl} className="btn-link button secondary">
                    {labelManagerLabels.goToCart}
                  </a>
                </div>
              ) : null}
              {sliderProductsACLine?.slug && lineId === 333 ? (
                <Link
                  className="cart-modal__close cart-modal__close--link mt-3 mt-md-4"
                  onClick={onHide}
                  to={normalizeRelativePath(safeSlugify(sliderProductsACLine?.slug))}
                  target="_self"
                >
                  {labelManagerLabels.cartModalRelatedProductsAc}
                </Link>
              ) : (
                <button className="cart-modal__close mt-3 mt-md-4" onClick={onHide}>
                  {labelManagerLabels.continueOnTheShop}
                </button>
              )}
            </div>
            {lineId !== 333 && sliderProducts?.length ? (
              <SliderRelated
                data={sliderProducts}
                ecommerceActive={ecommerceActive}
                config={config}
                compareProducts={sliderProducts}
                labelManagerLabels={labelManagerLabels}
                isCartModal
                onHide={onHide}
                setIsProducts={setIsProducts}
              />
            ) : null}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CartModal;
